import { CONSTANTS } from 'utils/constants';

const initialState = {
  slug: null,
  logo: null,
  referralQuestion: null,
  referralQuestionOptions: []
};

export const retailPartnerReducerKey = 'retailPartner';
export const retailPartnerReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_RETAIL_PARTNER': {
      return {
        ...state,
        slug: action.payload || null
      };
    }
    case 'CLEAR_RETAIL_PARTNER': {
      return {
        ...state,
        slug: null,
        logo: null
      };
    }
    case CONSTANTS.GET_RETAILER_LOGO.REQUEST:
      return {
        ...state,
        logo: null
      };
    case CONSTANTS.GET_RETAILER_LOGO.SUCCESS:
      return {
        ...state,
        logo: action.payload.logoFilename || null
      };
    case CONSTANTS.GET_RETAILER_REFERRAL_QUESTION.REQUEST:
      return {
        ...state,
        referralQuestion: null,
        referralQuestionOptions: []
      };
    case CONSTANTS.GET_RETAILER_REFERRAL_QUESTION.SUCCESS:
      return {
        ...state,
        referralQuestion: action.payload.question,
        referralQuestionOptions: action.payload.options
      };
    default:
      return state;
  }
};

export default retailPartnerReducer;
